import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "../pages/login/login";
import LoginSmsCode from "../pages/login/loginSmsCode";
import ProtectedRoute from "../components/protectedRoute/ProtectedRoute";
import MainContentLayout from "../components/mainContentLayout/mainContentLayout";
import { Category } from "../types/types";
import MainPage from "../pages/main/mainPage";
import ChatPage from "../pages/chat/ChatPage";
import ProfilePage from "../pages/profile/profile";
import NotFoundPage from "../pages/notFound/notFoundPage";
import TherapistTreatmentPlan from "../components/treatmentPlanTable/therapistTreatmentPlan";
import PendingReportsPage from "../pages/pendingReports/pendingReports";
import AddTreatmentPlan from "../components/addTreatmentPlan/addTreatmentPlan";
import PublicOnlyRoute from "../components/publicOnlyRoute/PublicOnlyRoute";
import SsoRedirectHandler from "../components/ssoRedirectHandler/ssoRedirectHandler";
import RecorderWav from "../components/meetingRecording/meetingRecording";
import RecordingsTable from "../components/meetingRecording/RecordingsTable/RecordingsTable";
import SummaryMeeting from "../components/meetingRecording/summaryMeeting/summaryMeeting";
import RecordMeetingSearch from "../components/recordMeetingSearch/recordMeetingSearch";
import Loader from "../components/loader/loader";
import GoogleCallbackPage from "../pages/googleCallbackPage/googleCallbackPage";

// Lazy-loaded pages
const RestorePasswordPage = lazy(() => import("../pages/restore_password/restorePasswordPage"));
const SigninPage = lazy(() => import("../pages/signin/signin"));
const UsersPage = lazy(() => import("../pages/users/usersPage"));
const EditDataPage = lazy(() => import("../pages/editData/editDataPage"));
const EditPersonalDataPage = lazy(() => import("../pages/editPersonalData/editPersonalDataPage"));
const DocumentsPage = lazy(() => import("../pages/documents/documentsPage"));
const ActionReportPage = lazy(() => import("../pages/actionReportPage/actionReportPage"));
const QuestionReportsPage = lazy(() => import("../pages/questionReports/questionReportsPage"));
const TherapistsQuestionsReports = lazy(() => import("../pages/therapistsQuestionsReports/therapistsQuestionsReports"));
const PrescriptionsPage = lazy(() => import("../pages/prescriptions/prescriptions"));
const LibraryPage = lazy(() => import("../pages/library/library"));
const SearchPage = lazy(() => import("../pages/search/SearchPage"));
const EditAvailabilityMonthlyPage = lazy(() => import("../pages/editAvailabilityPage/editAvailabilityMonthlyPage"));
const EditAvailabilityPage = lazy(() => import("../pages/editAvailabilityPage/editAvailabilityPage"));
const CalendarPage = lazy(() => import("../pages/calendar/calendar"));
const ForumPage = lazy(() => import("../pages/forum/forumPage"));
const NewPrescriptionPage = lazy(() => import("../pages/newPrescription/newPrescriptionPage"));
const SupportPage = lazy(() => import("../pages/support/SupportPage"));
const SupportApplicationPage = lazy(() => import("../pages/supportApplication/supportApplicationPage"));
const TermsPage = lazy(() => import("../pages/terms/termsPage"));
const AiChatPage = lazy(() => import("../pages/AiChatPage/AiChatPage"));
const TutorialPage = lazy(() => import("../pages/tutorial/tutorial"));


export const useRoutes = (
  isAuth: boolean,
  dataFromL:boolean,
  changeCategory: (
    e: React.MouseEvent<Element, MouseEvent>,
    cat: Category
  ) => void
) => (
  
  <Suspense fallback={<Loader />}>
  <Routes>
    <Route
      path={"/"}
      element={
        <PublicOnlyRoute isAuth={isAuth}>
          <LoginPage />
        </PublicOnlyRoute>
      }
    />
    {/* <Route
      path={"/signin"}
      element={
        <PublicOnlyRoute isAuth={isAuth}>
          <SigninPage />
        </PublicOnlyRoute>
      }
    /> */}
    <Route
      path={"/enter_code"}
      element={
        <PublicOnlyRoute isAuth={isAuth}>
          <LoginSmsCode />
        </PublicOnlyRoute>
      }
    />
    <Route
      path={"login/enter_code"}
      element={
        <PublicOnlyRoute isAuth={isAuth}>
          <LoginSmsCode />
        </PublicOnlyRoute>
      }
    />
    <Route path="/auth/sso" element={<SsoRedirectHandler />} />
    <Route path={"/restore_password"} element={<RestorePasswordPage />} />
    <Route
      path={"/main"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Main}
            changeCategory={changeCategory}
          >
            <MainPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/recordMeeting"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.RecordMeeting}
            changeCategory={changeCategory}
          >
            <RecordMeetingSearch />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <UsersPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/recording"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
           <RecorderWav/>
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/recordTable"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <RecordingsTable />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
   
    <Route
      path={"/users/update"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <EditDataPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/personal"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <EditPersonalDataPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/documents"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <DocumentsPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/report/"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <ActionReportPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/report"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <ActionReportPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/summaryMeeting/:recordNumber"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <SummaryMeeting />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    {/* Legacy route without recordNumber - redirects to table */}
    <Route
      path={"/users/summaryMeeting"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <SummaryMeeting />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/questions_reports"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <QuestionReportsPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    {/* <Route
      path={"/users/questions_reports"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <QuestionReportsPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    /> */}
    <Route
      path={"/users/prescriptions"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <PrescriptionsPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/users/treatment_plan"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <AddTreatmentPlan />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />     
    {/* <Route path="/users/ai-consultation" element={<AiChatPage />} /> */}

     <Route
      path={"/users/ai-consultation"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <AiChatPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
         
    <Route
      path={"/messages"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <ChatPage changeCategory={changeCategory} />
        </ProtectedRoute>
      }
    />
    <Route
      path={"/profile"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Profile}
            changeCategory={changeCategory}
          >
            <ProfilePage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/library"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Library}
            changeCategory={changeCategory}
          >
            <LibraryPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/google-callback"}
      element={<GoogleCallbackPage />}
    />
    <Route
      path={"/calendar/search"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Calendar}
            changeCategory={changeCategory}
          >
            <SearchPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/calendar/edit/monthly"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Calendar}
            changeCategory={changeCategory}
          >
            <EditAvailabilityMonthlyPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/calendar/edit"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Calendar}
            changeCategory={changeCategory}
          >
            <EditAvailabilityPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/calendar"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Calendar}
            changeCategory={changeCategory}
          >
            <CalendarPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />

    <Route
      path={"/treatmentPlan"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.TreatmentPlan}
            changeCategory={changeCategory}
          >
            <TherapistTreatmentPlan />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/forum"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Forum}
            changeCategory={changeCategory}
          >
            <ForumPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/prescriptions/new"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <NewPrescriptionPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/prescriptions/update/:medicine"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Users}
            changeCategory={changeCategory}
          >
            <NewPrescriptionPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/support"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Support}
            changeCategory={changeCategory}
          >
            <SupportPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/support/apply"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Support}
            changeCategory={changeCategory}
          >
            <SupportApplicationPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/tutorial"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Tutorial}
            changeCategory={changeCategory}
          >
            <TutorialPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/terms"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Terms}
            changeCategory={changeCategory}
          >
            <TermsPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/pendingReports"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Main}
            changeCategory={changeCategory}
          >
            <PendingReportsPage />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path={"/therapistsQuestionsReports"}
      element={
        <ProtectedRoute isAuth={isAuth} redirectPath={`/`}>
          <MainContentLayout
            activeCategory={Category.Main}
            changeCategory={changeCategory}
          >
            <TherapistsQuestionsReports />
          </MainContentLayout>
        </ProtectedRoute>
      }
    />
    <Route path={"*"} element={<NotFoundPage />} />
  </Routes>
  </Suspense>
);
